import { CSSProperties } from "react";

import styles from "./ToggleButtonComponent.module.css";

export const ToggleButtonComponent = ({
  checked,
  setChecked,
  style,
  children,
}: {
  checked: boolean;
  setChecked?: (checked: boolean) => void;
  style?: CSSProperties;
  children: any;
}) => {
  // const [checked, setChecked] = useState<boolean>(props.checked === undefined ? false : props.checked);

  // console.log(">", props.value);

  return (
    <div
      className={styles.main}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (setChecked) setChecked(!checked);
      }}
    >
      <label className={styles.switch} style={{ margin: 0 }}>
        <input type="checkbox" checked={checked} onChange={() => {}} />
        <span className={styles.slider + " " + styles.round}></span>
      </label>
      <div style={{ paddingLeft: 3 }}>{children}</div>
    </div>
  );
};
